function mostFrequent<T>(arr: readonly T[]): T[] {
  if (arr.length === 0) return [];

  const counts = new Map<T, number>();
  arr.forEach((item) => {
    counts.set(item, (counts.get(item) ?? 0) + 1);
  });

  let max = 0;
  counts.forEach((count) => {
    if (count > max) max = count;
  });

  const result: T[] = [];
  counts.forEach((count, value) => {
    if (count === max) result.push(value);
  });

  return result;
}

export default mostFrequent;
